// Agentation annotation → PageNoteInput (spec §3). Pure; no 'agentation' import (types are local).
import { PAGE_NOTE_DROP_QUERY_KEYS as DROP, PAGE_NOTE_LIMITS as L, type PageNoteBox, type PageNoteInput } from '../types';

export interface AnnotationLike {
  id: string; comment: string; element: string; elementPath: string; fullPath?: string; selectedText?: string;
  nearbyText?: string; cssClasses?: string; boundingBox?: { x: number; y: number; width: number; height: number };
}
const cut = (v: string | undefined | null, n: number) => (v ? String(v).slice(0, n) : null);
const fin = (v: unknown) => typeof v === 'number' && Number.isFinite(v);
// eslint-disable-next-line no-control-regex
const CONTROL = /[\u0000-\u001f\u007f]/;

/** Page path + search with secret keys removed. Always starts with exactly one '/' (browsers drop tabs and
 *  newlines and read '\' as '/', so those are removed first, then leading slashes are collapsed). */
export function scrubRoute(pathname: string, search: string): string {
  const q = new URLSearchParams(search);
  for (const k of [...q.keys()]) if ((DROP as readonly string[]).includes(k.toLowerCase())) q.delete(k);
  const s = q.toString();
  // eslint-disable-next-line no-control-regex
  const path = '/' + String(pathname ?? '').replace(/[\u0000-\u001f\u007f]/g, '').replace(/\\/g, '/').replace(/^\/+/, '');
  return (path + (s ? `?${s}` : '')).slice(0, L.route);
}
export function shortUa(ua: string): string {
  const m = /(Edg|Firefox|Chrome|Safari)\/(\d+)/.exec(ua);
  return m ? `${m[1]} ${m[2]}` : 'Browser';
}
/** A stored route we may navigate to: one leading '/', no '\', no control characters. */
export function safeRoute(route: string | null | undefined): string | null {
  return typeof route === 'string' && route.startsWith('/') && !route.startsWith('//') && !route.includes('\\') && !CONTROL.test(route) ? route : null;
}
function box(b: AnnotationLike['boundingBox']): PageNoteBox | null {
  return b && fin(b.x) && fin(b.y) && fin(b.width) && fin(b.height) ? { x: b.x, y: b.y, width: b.width, height: b.height } : null;
}
export function toNoteInput(a: AnnotationLike, loc: { pathname: string; search: string }, w: { innerWidth: number; innerHeight: number; devicePixelRatio: number; userAgent: string }): PageNoteInput {
  return {
    clientId: String(a.id).slice(0, L.clientId), route: scrubRoute(loc.pathname, loc.search),
    comment: String(a.comment ?? '').slice(0, L.comment), element: String(a.element ?? '').slice(0, L.element),
    elementPath: String(a.elementPath ?? '').slice(0, L.elementPath), fullPath: cut(a.fullPath, L.fullPath),
    selectedText: cut(a.selectedText, L.selectedText), nearbyText: cut(a.nearbyText, L.nearbyText), cssClasses: cut(a.cssClasses, L.cssClasses),
    box: box(a.boundingBox),
    viewport: { width: w.innerWidth, height: w.innerHeight, dpr: w.devicePixelRatio, ua: shortUa(w.userAgent) },
  };
}
